module.exports = __webpack_public_path__ + "assets/img/bcd378c5d995514e9281c48f2eeb65c0.svg";